import { SimulateMultiResultsPopUpModule } from './simulate-multi-results-pop-up/simulate-multi-results-pop-up.module';
import { EsoService } from './../eso.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDataGridModule, DxChartModule, DxTextAreaModule, DxPopupModule, DxRangeSelectorModule, DxAutocompleteComponent, DxAutocompleteModule, DxValidatorModule, DxValidationSummaryModule, DxDateBoxModule, DxProgressBarModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { SimulateMultiRoutingModule } from './simulate-multi-routing.module';
import { SimulateMultiComponent } from './simulate-multi.component';
import { SimulateMultiPopupModule } from '../simulate-multi-popup/simulate-multi-popup.module';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { DataGridComponent } from 'src/app/widgets/data-grid/data-grid.component';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';
import { BookmarksControlsComponent } from 'src/app/widgets/bookmark-new/bookmarks-controls/bookmarks-controls.component';
import { FileNameDatePipe } from 'src/app/pipes/file-name-date.pipe';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { WebExportModule } from 'src/app/widgets/web-export/web.export.module';


@NgModule({
	declarations: [SimulateMultiComponent],
	imports: [
		CommonModule,

		FileNameDatePipe,

		SimulateMultiRoutingModule,
		SimulateMultiPopupModule,
		SimulateMultiResultsPopUpModule,

		BookmarkModule,
		BookmarkNewComponent,
		BookmarksControlsComponent,
		HelpButtonComponent,
		FiltersGroupModule,
		ContainerComponent,
		DataGridComponent,
		DxTableControllerDirective,

		DxDataGridModule,
		DxChartModule,
		DevEpressCommonModule,
		DxTextAreaModule,
		DxPopupModule,
		DxRangeSelectorModule,
		DxAutocompleteModule,
		DxValidatorModule,
		DxValidationSummaryModule,
		DxDateBoxModule,
		DxProgressBarModule,WebExportModule,
	],
	providers: [EsoService]
})
export class SimulateMultiModule { }
